(() => {
  /* BEZELOR Super Deal on the product page: motion for the deal box, and the deal price inside the
     phone options sheet (the sheet otherwise copies the hidden normal sale price).
     Only runs on product pages opened from Super Deals (html.bz-sd-pdp-on). */
  const html = document.documentElement;
  const live = () => html.classList.contains('bz-sd-pdp-on') && !html.classList.contains('bz-sd-pdp-ended');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1. Deal box motion ---------- */
  const dress = (box) => {
    if (box.dataset.fx) return;
    box.dataset.fx = 'true';
    box.classList.add('bzfx');
    const layer = document.createElement('span');
    layer.className = 'bzfx-sparks';
    layer.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 14; i++) {
      const spark = document.createElement('i');
      spark.style.setProperty('--x', Math.round(Math.random() * 100) + '%');
      spark.style.setProperty('--d', (5 + Math.random() * 6).toFixed(2) + 's');
      spark.style.setProperty('--delay', (-Math.random() * 10).toFixed(2) + 's');
      spark.style.setProperty('--s', (2 + Math.random() * 3).toFixed(1) + 'px');
      layer.append(spark);
    }
    box.prepend(layer);
    const ring = document.createElement('span');
    ring.className = 'bzfx-ring';
    ring.setAttribute('aria-hidden', 'true');
    box.querySelector('.bz-sd-pdp__off')?.prepend(ring);

    /* Reveal once the box is on screen */
    const reveal = () => box.classList.add('is-in');
    if ('IntersectionObserver' in window && !reduce.matches) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          reveal();
          io.disconnect();
        }
      }, { threshold: 0.2 });
      io.observe(box);
      setTimeout(reveal, 2500);
    } else reveal();

    /* A small pulse on the timer every second, and a flash on the price when the variant changes */
    const timer = box.querySelector('[data-sd-countdown]');
    if (timer) {
      new MutationObserver(() => {
        timer.classList.remove('is-tick');
        void timer.offsetWidth;
        timer.classList.add('is-tick');
        /* Same countdown inside the options sheet */
        document.querySelectorAll('.bzfx-panel__timer b').forEach((node) => {
          node.textContent = timer.textContent;
        });
      }).observe(timer, { childList: true, characterData: true, subtree: true });
    }
    const deal = box.querySelector('[data-sd-deal]');
    if (deal) {
      let last = deal.textContent;
      new MutationObserver(() => {
        if (deal.textContent === last) return;
        last = deal.textContent;
        deal.classList.remove('is-flash');
        void deal.offsetWidth;
        deal.classList.add('is-flash');
        renderPanels();
      }).observe(deal, { childList: true, characterData: true, subtree: true });
    }
  };

  /* ---------- 2. Deal price inside the options sheet ---------- */
  const dealInfo = () => {
    const box = document.querySelector('[data-sd-pdp]');
    if (!box || box.dataset.sdShowPrice !== 'true' || !live()) return null;
    const deal = box.querySelector('[data-sd-deal]')?.textContent.trim();
    const wasNode = box.querySelector('[data-sd-was]');
    const was = wasNode && !wasNode.hidden ? wasNode.textContent.trim() : '';
    const pct = box.querySelector('[data-sd-pct]')?.textContent.trim() || '';
    const save = box.querySelector('[data-sd-save]')?.textContent.trim() || '';
    const ends = box.querySelector('[data-sd-countdown]')?.textContent.trim() || '';
    return deal ? { deal, was, pct, save, ends } : null;
  };
  const renderPanel = (priceCopy) => {
    const info = dealInfo();
    const actions = priceCopy.closest('dialog')?.querySelector('.bezelor-panel-actions');
    if (!info) {
      priceCopy.classList.remove('bzfx-panel');
      actions?.querySelector('.bzfx-sheet-note')?.remove();
      return;
    }
    /* A gold note above the button: the deal is taken off automatically */
    if (actions && !actions.querySelector('.bzfx-sheet-note')) {
      const strip = document.createElement('p');
      strip.className = 'bzfx-sheet-note';
      strip.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 2 5 13.5h6L10 22l9-12h-6.2z"/></svg><span>Super Deal price applied automatically in your cart</span>';
      actions.prepend(strip);
    }
    const key = [info.deal, info.was, info.pct].join('|');
    if (priceCopy.dataset.bzfx === key && priceCopy.querySelector('.bzfx-panel__deal')) return;
    priceCopy.dataset.bzfx = key;
    priceCopy.classList.add('bzfx-panel');
    /* Animate only when the price really changes, not each time the sheet redraws its copy */
    if (priceCopy.dataset.bzfxShown !== key) {
      priceCopy.dataset.bzfxShown = key;
      priceCopy.classList.remove('is-new');
      void priceCopy.offsetWidth;
      priceCopy.classList.add('is-new');
    }
    const amount = document.createElement('span');
    amount.className = 'bezelor-panel-current-price bzfx-panel__deal';
    amount.textContent = info.deal;
    const detail = document.createElement('div');
    detail.className = 'bezelor-panel-price-detail';
    const badge = document.createElement('span');
    badge.className = 'bzfx-panel__badge';
    badge.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 2 5 13.5h6L10 22l9-12h-6.2z"/></svg>';
    badge.append(document.createTextNode('Super Deal ' + info.pct));
    detail.append(badge);
    if (info.was) {
      const was = document.createElement('s');
      was.className = 'bezelor-panel-original-price';
      was.textContent = info.was;
      detail.append(was);
    }
    if (info.save) {
      const note = document.createElement('span');
      note.className = 'bzfx-panel__save';
      note.textContent = 'You save ' + info.save + ' · deal applied in cart';
      detail.append(note);
    }
    const parts = [amount, detail];
    if (info.ends) {
      const timerLine = document.createElement('span');
      timerLine.className = 'bzfx-panel__timer';
      timerLine.innerHTML = 'Ends in <b></b>';
      timerLine.querySelector('b').textContent = info.ends;
      parts.unshift(timerLine);
    }
    priceCopy.replaceChildren(...parts);
  };
  const watched = new WeakSet();
  const renderPanels = () => {
    document.querySelectorAll('dialog.bezelor-variant-panel .bezelor-panel-price').forEach((priceCopy) => {
      renderPanel(priceCopy);
      if (watched.has(priceCopy)) return;
      watched.add(priceCopy);
      /* The sheet rewrites its price whenever it opens or the variant changes */
      new MutationObserver(() => renderPanel(priceCopy)).observe(priceCopy, { childList: true });
    });
  };

  /* Instant deal price when the colour changes (the deal box otherwise catches up on its next
     one-second tick). Same maths as bezelor-super-deals.js. */
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };
  const syncBox = (variantId) => {
    const box = document.querySelector('[data-sd-pdp]');
    if (!box || box.dataset.sdShowPrice !== 'true' || box.dataset.sdVariant === variantId) return;
    let prices;
    try {
      prices = JSON.parse(box.dataset.sdPrices || '{}');
    } catch (e) {
      return;
    }
    const entry = prices[variantId];
    if (!Array.isArray(entry)) return;
    box.dataset.sdVariant = variantId;
    const price = entry[0];
    const original = Math.max(entry[1] || 0, price);
    const value = parseFloat(box.dataset.sdValue);
    let off = box.dataset.sdType === 'fixed' ? Math.round(value * 100) : Math.floor((price * value) / 100 + 0.00001);
    off = Math.min(off, price);
    const dealPrice = price - off;
    const totalOff = original - dealPrice;
    const currency = box.dataset.sdCurrency || 'GBP';
    const set = (selector, text) => {
      const node = box.querySelector(selector);
      if (node) node.textContent = text;
      return node;
    };
    set('[data-sd-deal]', money(dealPrice, currency));
    const was = set('[data-sd-was]', money(original, currency));
    if (was) was.hidden = original <= dealPrice;
    set('[data-sd-sale]', money(price, currency));
    const saleRow = box.querySelector('[data-sd-row-sale]');
    if (saleRow) saleRow.hidden = original <= price;
    set('[data-sd-extra]', money(off, currency));
    set('[data-sd-save]', money(totalOff, currency));
    if (original > 0) set('[data-sd-pct]', '-' + Math.round((totalOff * 100) / original) + '%');
    const sticky = document.querySelector('.bezelor-sticky-cart__meta span');
    if (sticky && live()) sticky.textContent = money(dealPrice, currency);
    renderPanels();
  };
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('product-info form input[name="id"]') || !input.value) return;
    if (live()) syncBox(input.value);
  }, true);

  const start = () => {
    const box = document.querySelector('[data-sd-pdp]');
    if (box && live()) dress(box);
    renderPanels();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* The box and the sheet are added by other scripts after load */
  let tries = 0;
  const poll = setInterval(() => {
    start();
    if (++tries > 30) clearInterval(poll);
  }, 300);
  new MutationObserver(() => renderPanels()).observe(html, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver((mutations) => {
    if (mutations.some((m) => m.target.matches && m.target.matches('dialog.bezelor-variant-panel') && m.target.open)) renderPanels();
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
